import React from 'react';

const WithdrawalSection = () => {
  const paymentMethods = [
    { name: 'UPI', logo: '💳', color: 'from-purple-500/20 to-purple-900/20' },
    { name: 'Net Banking', logo: '🏦', color: 'from-blue-500/20 to-blue-900/20' },
    { name: 'Bank Card', logo: '💳', color: 'from-green-500/20 to-green-900/20' },
    { name: 'Binance Pay', logo: '🔗', color: 'from-yellow-500/20 to-yellow-900/20' },
    { name: 'Tether USDT (ERC20)', logo: '₮', color: 'from-teal-500/20 to-teal-900/20' },
    { name: 'Tether USDT (TRC20)', logo: '₮', color: 'from-emerald-500/20 to-emerald-900/20' }
  ];

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-black"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-yellow-900/10 via-transparent to-transparent"></div>
      
      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-yellow-500/20 rounded-full animate-float-slow"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Title with animation */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            <span className="text-yellow-500 inline-block animate-pulse-slow">Quick withdrawal</span>
            <br />
            <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
              with local payment options
            </span>
          </h2>
        </div>

        {/* Payment Methods Cards with staggered animation */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-6xl mx-auto">
          {paymentMethods.map((method, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 border border-gray-800 hover:border-yellow-500/50 transition-all duration-500 group cursor-pointer animate-slide-up"
              style={{
                animationDelay: `${index * 0.1}s`,
                animationFillMode: 'both'
              }}
            >
              {/* Glow effect on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${method.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl blur-xl`}></div>
              
              {/* Card content */}
              <div className="relative flex flex-col items-center justify-center h-32">
                <div className="text-5xl mb-3 transform group-hover:scale-125 group-hover:rotate-12 transition-all duration-500 group-hover:animate-bounce-slow">
                  {method.logo}
                </div>
                <div className="text-sm text-gray-400 text-center font-medium group-hover:text-yellow-500 transition-colors duration-300">
                  {method.name}
                </div>
              </div>

              {/* Shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shine rounded-2xl"></div>
            </div>
          ))}
        </div>

        {/* Additional info with fade-in animation */}
        <div className="text-center mt-12 animate-fade-in" style={{ animationDelay: '0.8s', animationFillMode: 'both' }}>
          <p className="text-gray-400 text-lg">
            Fast, secure, and hassle-free withdrawals in minutes
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes float-slow {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-80px) translateX(40px);
            opacity: 0.8;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse-slow {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0) scale(1.25) rotate(12deg);
          }
          50% {
            transform: translateY(-10px) scale(1.25) rotate(12deg);
          }
        }

        @keyframes shine {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        .animate-float-slow {
          animation: float-slow linear infinite;
        }

        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out;
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }

        .animate-slide-up {
          animation: slide-up 0.6s ease-out;
        }

        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }

        .animate-bounce-slow {
          animation: bounce-slow 1s ease-in-out infinite;
        }

        .animate-shine {
          animation: shine 1.5s ease-in-out;
        }
      `}</style>
    </section>
  );
};

export default WithdrawalSection;
